import { Check } from "@material-ui/icons";
import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import reportingApi from "../../../core/api/reportingApi";
import {
  COLORS,
  ProductsAliasEnum,
  ProductsCodeEnum
} from "../../../core/consts/redesign/commonRedesign";
import { ArrowRight, PlusThin } from "../../../core/consts/redesign/icons";
import { changeReferenceUrl } from "../../../core/helpers/changeReferenceUrl";
import useIsInCart from "../../../core/hooks/useIsInCart";
import useIsMobile from "../../../core/hooks/useIsMobile";
import { pushToCart } from "../../../core/store/action-creators/cart";
import * as selectors from "../../../core/store/selectors";
import {
  ResponseItemDataType,
  TermTypeValue
} from "../../../core/types/proposalTypes";
import { ReferralReportType } from "../../../core/types/reportingTypes";
import { generateCID } from "../../../core/utils/generateCID";
import IconButtonMain from "../../../UIcomponentsRedesign/IconButtonMain/IconButtonMain";
import classes from "./SmallProposalCard.module.scss";
/* Redesign . Proposal card */

type PropsType = {
  id: number;
  proposal: ResponseItemDataType;
};

const SmallProposalCard: React.FC<PropsType> = ({ id, proposal }) => {
  const currentUser = useSelector(selectors.initialUser);
  const isInCart = useIsInCart(proposal ?? null);
  const dispatch = useDispatch();
  const product = proposal.productAlias;
  const isMobile = useIsMobile();
  const bankIcon = proposal && proposal.icon;
  const bankName = proposal.bankName;
  const proposalName = proposal.name;
  const sum = proposal.max_sum;
  const maxTerm = proposal.max_term;
  const maxTermType = proposal.max_term_type;
  const minRate = proposal.min_rate; // ставка
  const minFee = proposal.min_fee; //взнос

  const getTermTitle = (product: string) => {
    switch (product) {
      case ProductsCodeEnum.factoring:
        return "Отсрочка, до";
      case ProductsCodeEnum.rko:
        return "КВ агента до";
      default:
        return "Срок, до";
    }
  };

  const getPersentTitle = (product: string) => {
    switch (product) {
      case ProductsCodeEnum.lizing:
        return "Взнос, от";
      case ProductsCodeEnum.rko:
        return "Комиссия за снятие";
      default:
        return "Ставка, от";
    }
  };


  //solution for referral proposal. link or a blocked by browser because of utm medium
  const handleAddToCart = async () => {
    if (proposal.reference !== null && currentUser.inn) {
      const cid = generateCID();
      const modifiedReference = changeReferenceUrl(
        proposal.id,
        proposal.reference,
        currentUser.inn,
        cid
      );

      const referralReport: ReferralReportType = {
        ProposalId: proposal.id,
        URL: modifiedReference,
        CID: cid,
      };

      try {
        await reportingApi.postReferralReport(referralReport);
        window.open(modifiedReference, "_blank");
      } catch (error) {
        console.error("Error sending referral report:", error);
        window.open(modifiedReference, "_blank");
      }
    } else {
      dispatch && dispatch(pushToCart(proposal));
    }
  };

  const CardButton = () => {
    if (isInCart) {
      return (
        <div className={classes.tickBox} title='Уже в корзине'>
          <Check />
        </div >
      );
    }

    if (proposal.reference) {
      return (
        <IconButtonMain
          color='blue'
          className={classes.cardButton}
          aria-label="close"
          icon={<ArrowRight color={COLORS.white} />}
          handleClick={handleAddToCart}
          title='Перейти' />
      );
    }

    return (
      <IconButtonMain
        color='blue'
        className={classes.cardButton}
        aria-label="close"
        icon={<PlusThin color={COLORS.white} />}
        handleClick={handleAddToCart}
        title='Добавить в корзину' />
    );
  };

  return (
    <>
      <div id={id.toString()} className={classes.card}>
        <div className={classes.nameContainer}>
          <div className={classes.nameBox}>
            <img className={classes.imgIcon} src={bankIcon} alt="bank logo" />
            <div className={classes.colContainer}>
              <span className={classes.grayText}>{bankName}</span>
              <span className={classes.proposal}>{proposalName}</span>
            </div>
          </div>
          <CardButton />
        </div>
        {!isMobile &&
          <>
            <div className={classes.divider} />
            <div className={classes.descContainer}>
              <div className={classes.itemBox}>
                <span className={classes.grayText}>
                  {" "}
                  {proposal.productAlias === ProductsCodeEnum.rko
                    ? "Перевод фл, до"
                    : "Сумма, до"}
                </span>
                <span className={classes.blackText}>
                  {sum
                    ? new Intl.NumberFormat("ru", {
                      style: "currency",
                      currency: "RUB",
                      maximumFractionDigits: 0,
                    }).format(sum)
                    : ""}
                </span>
              </div>
              <div className={classes.dividerVert} />
              <div className={classes.itemBox}>
                <span className={classes.grayText}>
                  {getPersentTitle(product)}
                </span>
                <span className={classes.blackText}>
                  {" "}
                  {product === ProductsAliasEnum.lizing && minFee !== null
                    ? `${Math.round(minFee * 10) / 10}%`
                    : minRate !== null
                      ? `${Math.round(minRate * 10) / 10}%`
                      : ""}
                </span>
              </div>
              <div className={classes.dividerVert} />
              <div className={classes.itemBox}>
                <span className={classes.grayText}>{getTermTitle(product)}</span>
                <span className={classes.blackText}>
                  {product === ProductsCodeEnum.rko
                    ? minFee !== null && minFee !== undefined
                      ? new Intl.NumberFormat("ru", {
                        style: "currency",
                        currency: "RUB",
                        maximumFractionDigits: 0,
                      }).format(minFee)
                      : ""
                    : maxTermType !== null && maxTerm !== null
                      ? `${maxTerm} ${TermTypeValue[+maxTermType] || ""}`
                      : ""}
                </span>
              </div>
            </div>
          </>
        }

      </div>

    </>
  );
};

export default memo(SmallProposalCard);
